(function ($, Drupal) {
  'use strict'

  Drupal.behaviors.cookiepro = {
    attach: function (context, settings) {
      $('.optanon-toggle-display', context).attr('href', 'javascript:void(0)');
    }
  }

}) (jQuery, Drupal)